export enum EntityType {
    AUDIT_CAMPAIGN,
    AUDIT_RECORD,
    CONDITION_REPORT,
    MEDIA,
    WEMI,
}